module.exports = __webpack_public_path__ + "static/media/FiraSans-ExtraBold.288ae681.ttf";